export function appendFirstBlocks(blocks, result) {
  if (!result.meta) {
    result.meta = {
      header: {},
      summaryReport: {},
      peakTable: [],
    };
  }
  appendLinesToMeta(blocks.header, result.meta.header);
  appendLinesToMeta(blocks['Summary Report'], result.meta.summaryReport);
  appendPeakTable(blocks['Peak Table'], result.meta.peakTable);
}

function appendPeakTable(lines, peakTable) {
  // we should add the peakTable
  if (lines.length < 3) return;
  let labels = lines[1].map((label) => label.replace(/[\r\n]/g, '').trim());
  for (let i = 2; i < lines.length; i++) {
    const line = lines[i];
    const peak = {};
    line.forEach((column, index) => {
      let value =
        typeof column === 'string' ? Number(column.replace(/,/g, '')) : column;
      peak[labels[index]] = value;
    });
    peakTable.push(peak);
  }
}

function appendLinesToMeta(lines, summaryReport) {
  for (let fields of lines) {
    if (fields[0] && fields[1]) {
      summaryReport[fields[0]] = fields[1];
    }
    if (fields[2] && fields[3]) {
      summaryReport[fields[2]] = fields[3];
    }
  }
}
